<template>
  <div>
    <!--导航栏    @click-left="onClickLeft" start-->
    <!-- <van-nav-bar title="选择服务商" right-text="添加服务商" fixed @click-right="onClickRight" /> -->
    <!--导航栏 end-->
    <van-list v-model="loading" class="list select-shop" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(admin, index) in list" :key="index">
        <div class="list-item" @click="onSubmit(admin.agent_num)">
          <div class="txt1">{{ admin.name }}</div>
          <div style="display: flex;align-items: center;">
            <div class="txt2">{{ admin.agent_num }}</div>
            <img style="width: 24px;height: 24px;margin-left: 8px;" src="../../assets/images/right-icon.png" alt="" srcset="">
          </div>
        </div>
      </div>
      <div class="txt3" @click="onClickRight">
        <img style="width: 16px;height: 16px;margin-right: 8px;" src="../../assets/images/link.png" alt="" srcset="">
        <div>绑定新的服务商</div>
      </div>
      <!-- <van-cell
        v-for="(admin, index) in list"
        class="list-item"
        :key="index"
        size="large"
        :title="admin.name"
        is-link
        :value="admin.agent_num"
        @click="onSubmit(admin.agent_num)"
      /> -->
    </van-list>
  </div>
</template>

<script>

import { Image, Notify, Toast } from 'vant'

export default {
  name: 'AgentImpower', // 选择商户登录
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      limit: 10,
      ta: '222'
    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },
  mounted() {
    this.GetQueryString('openid')
  },
  methods: {
    // 左侧返回
    // onClickLeft() {
    //     this.$router.push("/");
    //     // window.history.go(-1)
    // },
    onClickRight() {
      this.$router.push('/AgentLogin')
      // Toast('添加商户');
    },

    GetQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        window.localStorage.setItem('openid', unescape(r[2]))
        return unescape(r[2])
      }

      return null
    },

    // 点击商户登录
    onSubmit(e) {
      window.sessionStorage.setItem('tag', this.ta)
      var toast = Toast.loading({
        duration: 0,
        message: '登录中',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.$http.get('/wechat/api.agent.login/login', {
        params: {
          openid: window.localStorage.getItem('openid'),
          account: e,
          type: 'agent'
        }
      }).then(response => {
        toast.clear()
        console.log('response', response.data)
        if (response.data.code == 200) {
          window.sessionStorage.setItem('token', response.data.data.token)
          window.sessionStorage.setItem('agent_id', response.data.data.agent_id)
          window.sessionStorage.setItem('commercialId', response.data.data.merchant_id)
          // window.sessionStorage.setItem("username",this.username)

          // this.$router.push('/AgentHomepage')
          this.$router.push('/Agent')

          // VueCookie.set('salesmanInfo', response.data.data, 360000);
          // window.location.href = that.redirect;
        } else {
          Notify({ type: 'danger', message: response.data.msg })
        }
      })
    },

    onLoad() {
      var that = this
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http.get('/wechat/api.agent.login/lst', {
        params: {
          // id: salesmanInfo.id,
          openid: window.localStorage.getItem('openid'),
          page: that.page,
          limit: that.limit,
          type: 'agent'

        }
      }).then(response => {
        // 加载状态结束
        that.loading = false
        // console.log(response.data.data)
        // that.list = that.list.concat(response.data)
        // console.log(that.list)
        // 页码

        // this.finished = true;
        if (response.data.data.length) {
          that.list.push(...response.data.data)
          that.finished = false
          that.page++
        } else { that.finished = true }
      })
    }

  }
}
</script>

<style scoped>
.list {
  /* margin-top: 1rem; */
  padding: 0.5rem;
  white-space: nowrap;
}

.list-item {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  height: 54px;
  padding: 0 10px;
  background-color: rgba(20, 134, 251, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .txt1 {
    max-width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
    color: #FFFFFF;
    font-size: 18px;
  }

  .txt2 {
    color: #FFFFFF;
    font-size: 18px;
  }
}

.txt3 {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 50px;
  font-size: 12px;
  color: #1486FB;
}
</style>
